import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_dashboard/campaigns/setup/delivery/integration/select",
)({
  component: () => <Outlet />,
});
